import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChatMessage } from '../../interfaces/chat-message.interface';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatMessageComponent {
  @Input() message!: ChatMessage;
}
